<template>
  <div>
    <div v-if="getEntries() > 0">
      <div class="row mt-4" v-if="loading == false">
        <div class="col-12 col-sm-12 col-md-6">
          <h4 class="font-weight-normal">Data Pool Recommendations</h4>
        </div>
        <div class="col-12 col-sm-12 col-md-6 mt-3 mt-md-0">
          <div class="box-gray-3 px-3 py-2">
            <p class="mb-0 h5 text-center">
              By modifying
              <strong>
                <!--{{
                  optimizer_data.data_optimization.summary.count 
                }} -->
                {{ getEntries() }}
                lines</strong
              >
              you can prevent
              <strong>{{
                optimizer_data.data_optimization.summary.total | currencyDolar
              }}</strong>
              in overages. To achieve the proposed savings, please select all
              lines.
            </p>
          </div>
        </div>
      </div>
      <div class="row my-4" v-if="loading == false">
        <div class="col-12 col-sm-12">
          <div class="line-blue-3 mb-4"></div>
          <div class="table-fixed-header">
            <table class="table-recommended">
              <thead>
                <tr>
                  <th>
                    <input
                      type="checkbox"
                      class=""
                      name=""
                      id=""
                      v-model="selectAllBuckets"
                    />
                  </th>
                  <th>User Name</th>
                  <th>Phone Line</th>
                  <th>Recommended Add-on</th>
                  <th>Add-on Cost</th>
                  <th>Quantity</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody
                v-for="(data, key) in optimizer_data.data_optimization.items"
                :key="key"
              >
                <tr v-for="(item, key2) in data.buckets" :key="key2">
                  <td>
                    <span v-if="item.submitted">
                      <span>&#10003;</span>
                    </span>
                    <span v-else>
                      <input
                        type="checkbox"
                        name=""
                        id=""
                        :value="item.bucket['id']"
                        v-model="selectedBuckets"
                      />
                    </span>
                  </td>
                  <td>{{ item.user_name }}</td>
                  <td>{{ item.phone_number | phoneNumber }}</td>
                  <td>{{ item.bucket["feature_name"] }}</td>
                  <td>{{ item.bucket["feature_price"] }}</td>
                  <td>{{ item.bucket["count"] }}</td>
                  <td>
                    <span v-if="item.bucket['feature_price']"
                      >${{
                        parseFloat(
                          item.bucket["feature_price"] * item.bucket["count"]
                        )
                          .toFixed(2)
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["optimizer_data", "loading"],
  data() {
    return {
      selectedBuckets: []
    };
  },
  async created() {},
  methods: {
    getEntries() {
      let rows = 0;
      if (this.optimizer_data.data_optimization) {
        this.optimizer_data.data_optimization.items.forEach(function(
          recomendation
        ) {
          let obj = recomendation.buckets;
          rows = obj.length;
          //console.log(obj);
        });
      }
      return rows;
    }
  },
  watch: {
    optimizer_data: function() {
      this.selectedBuckets = [];
    }
  },
  computed: {
    selectAllBuckets: {
      get: function() {
        let v = this.optimizer_data.data_optimization.items
          ? this.selectedBuckets.length ==
            this.optimizer_data.data_optimization.items.length
          : false;

        //console.log(this.selectedBuckets);
        //console.log("all");
        this.$emit("update:cats", this.selectedBuckets);
        return v;
      },
      set: function(value) {
        var selected = [];

        if (value) {
          this.optimizer_data.data_optimization.items.forEach(function(
            recomendation
          ) {
            let obj = recomendation.buckets;
            //console.log(obj);
            let dataopt = Object.values(obj);
            dataopt.forEach(function(bucket) {
              //console.log(bucket.bucket.id);
              selected.push(bucket.bucket.id);
            });
          });
        }

        this.selectedBuckets = selected;
        this.$emit("update:cats", selected);
      }
    }
  }
};
</script>
